module.exports = __webpack_public_path__ + "static/media/sim-smiling.7915b252.gif";